/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CreateCompanyUnitCommand } from '../models/create-company-unit-command';
import { UpdateCompanyUnitCommand } from '../models/update-company-unit-command';
@Injectable({
  providedIn: 'root',
})
class CompanyUnitService extends __BaseService {
  static readonly CreateCompanyUnitPath = '/api/organization/company-units';
  static readonly GetCompanyUnitForUpdatePath = '/api/organization/company-units/{id}/update';
  static readonly UpdateCompanyUnitPath = '/api/organization/company-units/{id}/update';
  static readonly DeleteCompanyUnitPath = '/api/organization/company-units/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param command undefined
   */
  CreateCompanyUnitResponse(command?: CreateCompanyUnitCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/organization/company-units`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateCompanyUnit(command?: CreateCompanyUnitCommand): __Observable<null> {
    return this.CreateCompanyUnitResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetCompanyUnitForUpdateResponse(id: string): __Observable<__StrictHttpResponse<UpdateCompanyUnitCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/company-units/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateCompanyUnitCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetCompanyUnitForUpdate(id: string): __Observable<UpdateCompanyUnitCommand> {
    return this.GetCompanyUnitForUpdateResponse(id).pipe(
      __map(_r => _r.body as UpdateCompanyUnitCommand)
    );
  }

  /**
   * @param params The `CompanyUnitService.UpdateCompanyUnitParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateCompanyUnitResponse(params: CompanyUnitService.UpdateCompanyUnitParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/organization/company-units/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `CompanyUnitService.UpdateCompanyUnitParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateCompanyUnit(params: CompanyUnitService.UpdateCompanyUnitParams): __Observable<null> {
    return this.UpdateCompanyUnitResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteCompanyUnitResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/organization/company-units/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteCompanyUnit(id: string): __Observable<null> {
    return this.DeleteCompanyUnitResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module CompanyUnitService {

  /**
   * Parameters for UpdateCompanyUnit
   */
  export interface UpdateCompanyUnitParams {
    id: string;
    command?: UpdateCompanyUnitCommand;
  }
}

export { CompanyUnitService }
